
export class InvoiceListSummaryVo{

    numberOfInvoicesWithAnafErrorsInCurrentMonth : number | undefined = undefined;
    numberOfAwaitingTaxSubmissionInvoicesInCurrentMonth : number | undefined = undefined;
    numberOfAwaitingTaxProcCompletionInvoicesInCurrentMonth : number | undefined = undefined;
    shouldDisplay : boolean | undefined = undefined;
}
